import type { ComponentProps } from "react";
import type { WorkOsWidgets } from "@workos-inc/widgets";
import { fontFamilyUI } from "@karda/design-tokens";

type WorkOsTheme = ComponentProps<typeof WorkOsWidgets>["theme"];

/**
 * Bridges the KARDA design language into the WorkOS/Radix widgets as far as
 * their theme API allows. The Radix theme prop only accepts NAMED accent
 * colors — arbitrary brand hex is not supported — so "indigo" stands in as
 * the closest named accent to the KARDA navy; deeper alignment would need
 * the widgets' `elements` prop or CSS-variable overrides on .radix-themes.
 */
export function getWorkOsWidgetTheme(mode: "light" | "dark"): WorkOsTheme {
  return {
    appearance: mode,
    accentColor: "indigo",
    grayColor: "slate",
    radius: "medium",
    fontFamily: fontFamilyUI,
  };
}
